import * as API from './api'
import * as Types from './Types'

export function tryResetApartment(token, communityId, apartmentId) {
  return dispatch => {
    dispatch({
      type: Types.RESET_APARTMENT
    })

    API.resetApartment(token, communityId, apartmentId)
      .then(response => {
        dispatch({
          type: Types.RESET_APARTMENT_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.RESET_APARTMENT_FAILED,
          payload: status
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/Apartments.js